export const tabOption = [
  { type: 'card', label: 'Card View' },
  { type: 'calendar', label: 'Calendar View' },
];

export default tabOption;
